import { Box, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContainerWrapper from "../../components/ContainerWrapper/ContainerWrapper";
import ActionButton from "../../components/Button/ActionButton";
import { CONFIGURATIONS_PATH } from "../../utils/paymentsRoutes";
import { semanticColors } from "../../utils/colors";
import { typography } from "../../utils/typography";
import { pageTitleSx } from "../../utils/pageStyles";

/**
 * Where confirming the documents leads.
 *
 * The configuration hub is the wrong place to land after submitting: it lists
 * the three requirements as things still to do, which reads as though nothing
 * happened. There is genuinely nothing left for the professional to do here —
 * the review is Easypay's — so the screen says only that, and shows the way
 * out.
 */
export default function PaymentConfigurationInReview() {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <ContainerWrapper>
      <Box
        sx={{
          maxWidth: "620px",
          mx: "auto",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          textAlign: "center",
          bgcolor: semanticColors.surface.canvas,
          borderRadius: "16px",
          border: `1px solid ${semanticColors.border.middle}`,
          boxShadow: "0px 0px 8px rgba(30,39,79,0.08)",
          px: { xs: "24px", sm: "40px" },
          py: "40px"
        }}
      >
        <Typography sx={pageTitleSx}>{t("paymentInReview.title")}</Typography>
        <Typography
          sx={{
            ...typography.body.l,
            color: semanticColors.text.secondary
          }}
        >
          {t("paymentInReview.message")}
        </Typography>
        <ActionButton
          label={t("paymentInReview.back")}
          onClick={() => history.push(CONFIGURATIONS_PATH)}
        />
      </Box>
    </ContainerWrapper>
  );
}
